import React from "react";
import { Bell } from "lucide-react";
import { cn } from "../../lib/utils";
import { Logo } from "./Logo";
import { NavigationTabs } from "./navigation-tabs";
import { HeaderActions } from "./header-actions";
import { UserProfileDropdown } from "./user-profile-dropdown";
import NotificationBell from "../../icons/notifications_unread.svg";

export function ShellHeader({
  logo = { text: "MERCHANTS", url: null, alt: "Logo", onClick: null },
  navigation = {
    tabs: [
      { id: "loans", label: "Loans", path: "/borrower-portal/loans", active: true },
      {
        id: "draw-request",
        label: "Draw Request",
        path: "/draw-request/loans",
        active: false,
      },
    ],
    onTabClick: null,
    activeRoute: "/borrower-portal/loans",
  },
  hasLeftNavigation = true,
  hasRightNavigation = true,
  actions = {
    showCheckRates: true,
    showApplyLoan: true,
    onCheckRatesClick: null,
    onApplyLoanClick: null,
    disableApplyLoan: false
  },
  user = {
    initials: "RH",
    image: null,
    name: "Rossie",
    onLogout: null,
    onProfileClick: null,
    // onNotificationClick: null,
  },
  className = "",
}) {
  return (
    <header
      className={cn(
        "flex items-center justify-between mx-12 py-4 relative",
        className
      )}
    >
      <div className="flex items-center space-x-12">
        {/* Logo */}
        <Logo text={logo.text} logoUrl={logo.url} onClick={logo.onClick} />

        {/* Navigation - moved closer to logo */}
        {hasLeftNavigation && (
          <NavigationTabs
            tabs={navigation.tabs}
            onTabClick={navigation.onTabClick}
            activeRoute={navigation.activeRoute}
          />
        )}
      </div>

      {/* Right side actions */}
      {hasRightNavigation && (
        <div className="flex items-center space-x-6">
          {/* Fixed button props to use correct variant names */}
          <HeaderActions
            showCheckRates={actions.showCheckRates}
            showApplyLoan={actions.showApplyLoan}
            onCheckRatesClick={actions.onCheckRatesClick}
            onApplyLoanClick={actions.onApplyLoanClick}
            disableApplyLoan={actions.disableApplyLoan}
          />

          <NotificationBell/>

          <UserProfileDropdown
            userInitials={user.initials}
            userImage={user.image}
            userName={user.name}
            onProfileClick={user.onProfileClick}
            onLogoutClick={user.onLogout}
          />
        </div>
      )}
    </header>
  );
}
